import type { RolesProvider } from './interfaces/roles.provider'
import { IamRoleEnum } from '../enums/iam-role.enum'

export function getRolesProvider(): RolesProvider {
  return () => {
    // Change this function to return a more human-friendly name
    // for a given role if you need to.
    function getRoleDisplayName(role: string): string {
      return role
    }

    return {
      roles: Object.values(IamRoleEnum),
      getRoleDisplayName,
    }
  }
}
